import { useState } from "react";
import { Image, Modal, ModalBody } from "react-bootstrap";
import UiButton from "../button/Button";

import { CrossIcon } from "constants/Images";
import "./bonus-history-modal.css"
import * as APITypes from "../../../constants/API";
import axios from "axios";
import isObjectEmpty from "utils/isObjectEmpty";
import CustomizationLoader from "../customization-loader/CustomizationLoader";
import prefillDeathCoverGraphSliderAllAmounts from "utils/forward-reverse-methods/prefillDeathCoverGraphSliderAllAmounts";
import ProductNames from "constants/ProductNames";
const BonusHistoryModal = (props) => {

    const { productName, productData, form } = props
    const [showBonusHistoryModal, setShowBonusHistoryModal] = useState(false)
    const [BonusHistoryData, setBonusHistoryData] = useState({})
    const premium_amount = prefillDeathCoverGraphSliderAllAmounts(productData?.data);

    const showBonusHistoryTableModal = async () => {
        setShowBonusHistoryModal(true)
        let requestData = {
            product_name: productName,
            product_id: productData?.data?.product_id,
            package_id: productData?.data?.package_id,
            pt: productData?.data?.bi_request?.PR_PT,
            ppt: productData?.data?.bi_request?.PR_PPT,
            sum_assured: Math.round(productData?.data?.parsedResponse?.SA),
            income_start_year: getIncomeStartYear(productData?.data?.product_id),
            plan_option: getPlanOption(productData?.data?.product_id)
        }
        const response = await axios.post(APITypes.BONUS_HISTORY_CALCULATION, requestData);
        if (response?.status === "success") {
            setBonusHistoryData(response?.data)
        }
    }

    const getIncomeStartYear = (productId) => {
        let incomeStartYear = ""
        switch (productId) {
            case ProductNames.flexiSavingsPlan:
                incomeStartYear = form?.$('income-start-year')?.value?.label
                break;
            default:
                incomeStartYear = ""
                break;
        }
        return incomeStartYear;
    }

    const getPlanOption = (productId) => {
        let planOption = ""
        switch (productId) {
            case ProductNames.legacyPlus:
            case ProductNames.flexiDreamPlan:
                planOption = form?.$('plan-option')?.value?.id
                break;
            default:
                planOption = ""
                break;
        }
        return planOption;
    }
    return (
        <div className="">
            <span
                className={`btn p-0 LA-btn font-size-14 bonus-history-button ${props.style}`}
                onClick={() => showBonusHistoryTableModal()}
            >
                Bonus History Calculation
            </span>

            <Modal
                show={showBonusHistoryModal}
                onHide={() => setShowBonusHistoryModal(false)}
                aria-labelledby=""
                className='bonus-history-modal'
                centered
                keyboard={false}
            >
                <Modal.Header
                    closeButton={false}
                    className="pb-0 mx-md-2 border-bottom-0 "
                >
                    <div className="d-flex justify-content-end w-100">

                        <UiButton
                            variant=""
                            className="d-inline-flex align-self-start justify-content-end p-0 ml-2"
                            onClick={() => setShowBonusHistoryModal(false)}
                        >
                            <span className="mr-2 cancel-btn-style">Cancel</span>
                            <Image
                                className="close-icon-class"
                                src={CrossIcon}
                            />
                        </UiButton>
                    </div>
                </Modal.Header>
                <ModalBody >
                    <>
                    <p>Here's a sample calculation of bonus for this product using historical rates of previous year(s)! </p>
                        {!isObjectEmpty(BonusHistoryData) ?
                            <table border="1" className="m-3 text-center bonus-history-table">
                                <thead>
                                    <tr>
                                        {BonusHistoryData.headers.map((header, index) => (
                                            <th key={index}>{header}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {BonusHistoryData.list.map((row, index) => (
                                        <tr key={index}>
                                            <td>{row.year}</td>
                                            <td>{premium_amount?.selectedPremium}</td>
                                            {BonusHistoryData.headers.includes("Cash bonus value") && <td>{row.cash_bonus_value}</td>}
                                            {BonusHistoryData.headers.includes("Reversionary bonus value") && <td>{row.reversionary_bonus_value}</td>}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            :
                            <div className="m-5">
                                <CustomizationLoader />
                            </div>
                        }
                    </>
                </ModalBody>
            </Modal>
        </div>
    )
}
export default BonusHistoryModal;
